import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Grid from '../components/Grid';
import SquareModal from '../components/SquareModal';
import '../assets/css/global.css'; // Add custom styles for the Home page

const Home = () => {
    const [squares, setSquares] = useState(
        Array.from({ length: 100 }, (_, i) => ({
            label: `A${i + 1}`,
            purchased: false,
            playerName: '',
            userName: '',
        }))
    );

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedSquare, setSelectedSquare] = useState(null);

    const saveGridState = (updatedSquares) => {
        setSquares(updatedSquares);
        localStorage.setItem('gridState', JSON.stringify(updatedSquares));
    };

    const handleSquareClick = (index) => {
        if (!squares[index].purchased) {
            setSelectedSquare({ ...squares[index], index });
            setModalOpen(true);
        }
    };

    const handleModalSubmit = ({ playerName, userName }) => {
        const updatedSquares = squares.map((square, i) =>
            i === selectedSquare.index
                ? { ...square, purchased: true, playerName, userName }
                : square
        );
        saveGridState(updatedSquares);
        setModalOpen(false);
    };

    useEffect(() => {
        const savedState = localStorage.getItem('gridState');
        if (savedState) {
            setSquares(JSON.parse(savedState));
        }
    }, []);

    return (
        <div>
            <Header />
            <section id="grid">
                <Grid squares={squares} onSquareClick={handleSquareClick} />
            </section>
            <section id="modal">
                <SquareModal
                    isOpen={isModalOpen}
                    onClose={() => setModalOpen(false)}
                    onSubmit={handleModalSubmit}
                    selectedSquare={selectedSquare}
                />
            </section>
        </div>
    );
};

export default Home;